/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated do not edit it manually",
 */
import React from "react";

import { offering } from "../assets/offering";
import { Icon, type IconBaseProps } from "../icon";

export const IconOffering = (props: IconBaseProps) => <Icon {...props} svg={offering} />;

IconOffering.displayName = "IconOffering";
